import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-textNote",
  "use": "icon-textNote-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-textNote\">\n   \n    \n        <path d=\"M23,2 L23,22 L1,22 L1,2 L23,2 Z M21,4 L3,4 L3,20 L21,20 L21,4 Z M17.3,6.28333333 L17.3,8.66333333 L13.3769231,8.66333333 L13.3769231,18.1833334 L11.0230769,18.1833334 L11.0230769,8.66333333 L7.09999999,8.66333333 L7.09999999,6.28333333 L17.3,6.28333333 Z\" />\n    \n</symbol>"
});
var result = sprite.add(symbol);
export default symbol